const C = require("../constants");

const productVariantsDialog = (data) => {
    return {
        type: C.PRODUCT_VARIANTS_DIALOG,
        data
    }
};

export {productVariantsDialog};


// WEBPACK FOOTER //
// ./src/actions/ProductVariantsDialogActions.js